import React from 'react';
import * as PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import CSSModules from 'react-css-modules';
import styles from './styles.styl';

function Calendar({ styles: _styles, ...props }) {
  return <DatePicker {...props} calendarClassName={_styles.root} />;
}

Calendar.propTypes = {
  styles: PropTypes.object,
};

export default CSSModules(Calendar, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/Calendar/index.jsx